import { Component, OnInit, OnDestroy, ChangeDetectorRef, forwardRef, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Router, ActivatedRoute } from '@angular/router';
import { ModuleListModel } from '../models/ModuleListModel';
import { ModuleModel } from '../models/ModuleModel';
import { Store } from '@ngrx/store';
import { TileState } from '../../pillar/dashboard/store/state/TileState';
import * as fromStore from '../store/reducers';
import { ModuleConfiguration } from '../business-rule.module.config';
import * as actions from '../../pillar/dashboard/store/actions';
import { TileContainer } from '../../pillar/dashboard/services/TileContainer';
import { MatTabGroup } from '@angular/material/tabs';
import { RouteHistorySubTab } from '../../pillar/layout/route-history-sub-tab';
import { RouteHistoryService } from '../../pillar/layout/route-history.service';

@Component({
  selector: 'brd-rule-collection-dashboard',
  providers: [{ provide: TileContainer, useExisting: forwardRef(() => RuleCollectionDashboardComponent) }],
  templateUrl: './rule-collection-dashboard.component.html',
  styleUrls: ['./rule-collection-dashboard.component.scss']
})
export class RuleCollectionDashboardComponent extends TileContainer implements OnInit, OnDestroy {
  static dashboardName = 'rule-collection';
  displayedColumns = ['rName'];
  moduleDisplayName: string;
  errors$: Observable<string[]>;
  destroyed$: Subject<boolean> = new Subject<boolean>();
  dataSet: ModuleListModel;
  loading: boolean = false;
  currentTab: number = 0;
  @ViewChild('tabGroup')
  tabGroup: MatTabGroup;

  constructor(
    private route: ActivatedRoute,
    private store: Store<TileState<ModuleListModel, ModuleModel>>,
    private router: Router,
    private changeDetectorRef: ChangeDetectorRef,
    public historyService: RouteHistoryService) {
    super();
  }

  ngOnInit() {
    this.route.params.take(1).subscribe(p => {
      this.moduleDisplayName = p['module'];
    });

    this.store.select(fromStore.getRuleList)
      .takeUntil(this.destroyed$)
      .subscribe(dataSets => {
        this.dataSet = dataSets.find(ds => ds.moduleDisplayName === this.moduleDisplayName);
        this.changeDetectorRef.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
  }

  tabClick( event: any ) {
    this.currentTab = event.index;
    var currTab = new RouteHistorySubTab(ModuleConfiguration.moduleName, event.tab.textLabel, event.index);
    this.historyService.setLastSubTab(currTab);
  }

  ngAfterViewInit() {
    if (this.historyService.lastSubTab && this.historyService.lastSubTab.moduleName == ModuleConfiguration.moduleName) {
      this.currentTab = this.historyService.lastSubTab.tabIndex;
      this.tabGroup.selectedIndex = this.historyService.lastSubTab.tabIndex;
      this.tabGroup.selectedTabChange.subscribe(s => this.tabGroup.selectedIndex = this.historyService.lastSubTab.tabIndex);
    } else {
      this.currentTab = 0;
    }
    this.store.dispatch(new actions.QueryListAction(ModuleConfiguration.moduleName, 
      ModuleListModel,
      {
        page: 0,
        pageSize: 200,
        sortDirection: "asc"
      }));
      
    this.changeDetectorRef.detectChanges();
  }
}



// WEBPACK FOOTER //
// ./src/app/businessRule/components/rule-collection-dashboard.component.ts